import * as yup from "yup";

import { QuestionType } from "pages/eligibility/type";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";
import FormQuestionAddress from "./address";
import FormQuestionArray from "./array";
import FormQuestionBoolean from "./boolean";
import FormQuestionDate from "./date";
import FormQuestionDateRange from "./date-range";
import FormQuestionEmail from "./email";
import FormQuestionFaxNumber from "./fax";
import FormQuestionFormatted from "./formatted";
// import FormQuestionLanguage from "./language";
import FormQuestionHouseholdMember from "./member";
import FormQuestionMoney from "./money";
import FormQuestionSelect from "./select";
import FormQuestionText from "./text";
import FormQuestionUpload from "./upload";
import FormQuestionUsState from "./us-state";
import FormQuestionMultiple from "./multiple";
import FormQuestionPhoneNumber from "./phone-number";

export const types = {
  FormQuestionAddress,
  FormQuestionArray,
  FormQuestionBoolean,
  FormQuestionDate,
  FormQuestionDateRange,
  FormQuestionEmail,
  FormQuestionFaxNumber,
  FormQuestionFormatted,
  FormQuestionHouseholdMember,
  FormQuestionMoney,
  FormQuestionMultiple,
  FormQuestionPhoneNumber,
  FormQuestionSelect,
  FormQuestionText,
  FormQuestionUpload,
  FormQuestionUsState,
} as Record<QuestionType, any>;

export const defaultValidator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.StringSchema> => {
  const key = keyFromIdentity(question.identity, parent, index);
  const value = yup.string();
  return { [key]: question.required ? value.required() : value };
};

export const typeValidators = Object.entries(types).reduce((acc, [typeName, type]) => ({
  ...acc,
  [typeName]: typeof type.validator === "undefined" ? defaultValidator : type.validator,
}), {}) as Record<QuestionType, any>;

const defaultInitial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
) => ({
  [keyFromIdentity(question.identity, parent, index)]: "",
});

const initials = Object.entries(types).reduce((acc, [typeName, type]) => ({
  ...acc,
  [typeName]: typeof type.initial === "undefined" ? defaultInitial : type.initial,
}), {}) as Record<QuestionType, any>;

export const getInitialValue = (
  question: QuestionProps,
  questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, any> => {
  const initialValue = (
    initials[question.__typename] ? (
      initials[question.__typename](question, questionsMap, parent, index)
    ) : {});

  return question.children.reduce((valuesMap, questionIdentity) => {
    const childKey = keyFromIdentity(questionIdentity);
    const childQuestion = questionsMap[childKey];
    if (!childQuestion) {
      console.error(`Question ${childKey} not found`);
      return valuesMap;
    }
    return ({
      ...getInitialValue(
        childQuestion,
        questionsMap,
        parent,
        index,
      ),
      ...valuesMap,
    });
  }, initialValue);
};
